import React from "react";
import Icon from "@ant-design/icons";

const NotificationBellSvg = ({
	width = "1rem",
	height = "1rem",
	fill = "none",
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		<path
			d="M19.8091 22.7756C22.3352 22.476 24.7711 21.8821 27.0815 21.0292C25.1658 18.9027 23.9997 16.0875 23.9997 13V12.0656C23.9999 12.0437 24 12.0219 24 12C24 7.58172 20.4183 4 16 4C11.5817 4 8 7.58172 8 12L7.99974 13C7.99974 16.0875 6.8337 18.9027 4.91797 21.0292C7.22854 21.8821 9.66458 22.4761 12.1908 22.7757M19.8091 22.7756C18.56 22.9238 17.2888 23 15.9997 23C14.7109 23 13.4398 22.9238 12.1908 22.7757M19.8091 22.7756C19.9331 23.1615 20 23.5729 20 24C20 26.2091 18.2091 28 16 28C13.7909 28 12 26.2091 12 24C12 23.573 12.0669 23.1615 12.1908 22.7757"
			stroke="#344054"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		{/* <path
			d="M9.90457 11.3878C11.1676 11.238 12.3855 10.941 13.5408 10.5146C12.5829 9.45134 11.9999 8.04376 11.9999 6.5V6.03279C12 6.02187 12 6.01094 12 6C12 3.79086 10.2091 2 8 2C5.79086 2 4 3.79086 4 6L3.99987 6.5C3.99987 8.04376 3.41685 9.45134 2.45898 10.5146C3.61427 10.9411 4.83229 11.238 6.09542 11.3878M9.90457 11.3878C9.27999 11.4619 8.64438 11.5 7.99987 11.5C7.35545 11.5 6.71992 11.4619 6.09542 11.3878M9.90457 11.3878C9.96654 11.5807 10 11.7865 10 12C10 13.1046 9.10457 14 8 14C6.89543 14 6 13.1046 6 12C6 11.7865 6.03346 11.5808 6.09542 11.3878"
			stroke="#344054"
			stroke-width="0.75"
			stroke-linecap="round"
			stroke-linejoin="round"
		/> */}
	</svg>
);
const NotificationBellIcon = (props) => (
	<Icon component={() => <NotificationBellSvg {...props} />} />
);

export default NotificationBellIcon;
